<template>
  <!-- 对话框 -->
  <el-drawer :visible.sync="show" :with-header="false" :before-close="closeDialog" size="80%">

    <!-- 基本信息表单 -->
    <div class="form-box">



      <template>

        <el-form ref="form" :model="submit_data" label-width="80px" style="height: 90vh; overflow-y: auto;">

          <el-form-item label="标题:" label-width='120px'>
            <el-input v-model="submit_data.title" :placeholder="submit_rules.title.placeholder" style="width: 80%;">
            </el-input>
          </el-form-item>


          <el-form-item label="端口:" label-width='120px'>
            <el-select v-model="submit_data.port" placeholder="请选择端口" style="width: 150px; margin-right: 20px;"
              clearable>
              <el-option label="司机端" value="driver"></el-option>
              <el-option label="乘客端" value="consumer"></el-option>
            </el-select>
          </el-form-item>



          <el-form-item label="城市:" label-width='120px'>
            <el-select v-model="value_city_code" placeholder="请选择城市" style="width: 150px; margin-right: 20px;"
              @visible-change="cityVisibleChange" @change="cityChange" clearable>
              <el-option v-for="item in options_city_code" :key="item.value" :label="item.city.name"
                :value="item.city.city_code">
              </el-option>
            </el-select>
            <span v-if="company_name!=''">隶属公司:{{ company_name }}</span>
          </el-form-item>



          <el-form-item label="内容:" label-width='120px'>

            <quill-editor ref="myTextEditor" v-model="submit_data.content" :options="submit_rules.content">
            </quill-editor>

          </el-form-item>

          <el-form-item label="关键字:" label-width='120px'>
            <el-tag :key="tag" v-for="tag in dynamicTags" :disable-transitions="false" closable
              @close="handleClose(tag)">
              {{ tag }}
            </el-tag>
            <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small"
              @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput" icon="el-icon-plus"></el-button>
          </el-form-item>




        </el-form>



        <!-- 对话框底部按钮 -->
        <div style="display: flex;justify-content: center;margin-top: 20px;">
          <el-button type="primary" @click="onSubmit">保存</el-button>
          <el-button @click="closeDialog">关闭</el-button>
        </div>

      </template>

    </div>




  </el-drawer>
</template>

<script>
  var _this;

  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  import {
    quillEditor
  } from 'vue-quill-editor';
  export default {
    components: {
      quillEditor
    },
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;
        _this.$post(
            "/help/getHelpDetails", {
              help_code: _this.data
            }
          )
          .then(res => {

            _this.submit_data.help_code = res.data.help_code;
            _this.submit_data.title = res.data.title;
            _this.submit_data.content = res.data.content;
            _this.submit_data.city_code = res.data.city.city_code;
            _this.submit_data.port = res.data.port.val;
            _this.value_city_code = res.data.city.name;


            _this.dynamicTags = res.data.key_synchronization;

            


            _this.$post(
                "/city/getCityDetails", {
                  city_code: _this.submit_data.city_code
                }
              )
              .then(res => {


                _this.company_name = res.data.company.name;



              }).catch(res => {

              })


          }).catch(res => {

          })

      },
    },
    data() {
      return {

        show: false,


        // 下拉搜索城市
        value_city_code: '',
        options_city_code: [],
        city_options_data: {
          page: 1,
          limit: 50,
          name: ''
        },
        company_name: '',

        // 关键字标签
        dynamicTags: [],
        inputVisible: false,
        inputValue: '',

        // 表单数据
        submit_data: {
          title: '',
          content: '',
          port: '',
          city_code: '',
          key_synchronization: ''
        },



        submit_rules: {
          title: {
            placeholder: '请输入标题',
            rules: {
              required: true,
              message: '标题不能多于50字',
              regulation: 'lt_str',
              rulesData: 50
            }
          },
          content: {
            placeholder: '请输入内容',
            rules: {
              required: true,
              message: '内容不能多于200字',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          port: {
            placeholder: '端口',
            rules: {
              required: true,
              message: '端口选择错误',
              regulation: 'egt_str',
              rulesData: 0
            }
          },
          city_code: {
            placeholder: '城市编码',
            rules: {
              required: true,
              message: '城市编码错误',
              regulation: 'special',
              rulesData: 'city_code'
            }
          },
          key_synchronization: {
            placeholder: '',
            rules: {
              required: true,
              message: '关键字输入错误',
              regulation: 'egt_str',
              rulesData: 0
            }
          }
        },

      };
    },
    created() {

      _this = this;

    },
    methods: {
      handleClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },

      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          this.dynamicTags.push(inputValue);
        }
        _this.inputVisible = false;
        _this.inputValue = '';
      },

      showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          _this.$refs.saveTagInput.$refs.input.focus();
        });
      },

      cityChange(val) {

        _this.submit_data.city_code = val;
        if (val != '') {

          _this.$post(
            "/city/getCityDetails", {
              city_code: val
            }
          ).then(res => {

            _this.company_name = res.data.company.name;

          }).catch((err) => {

          })

        } else {
          _this.company_name = '';
        }



      },
      //搜索的下拉框弹出触发
      cityVisibleChange(val) {
        if (val && _this.options_city_code.length < 1) {
          // 请求公司管理接口获取公司唯一编码
          _this.$post(
            "/city/cityLists",
            _this.city_options_data
          ).then(res => {
            _this.options_city_code = res.data

          }).catch((err) => {

          })
        }

      },


      // 关闭方法
      closeDialog() {
        _this.show = false;

        for (const key in _this.submit_data) {
          _this.submit_data[key] = '';
        }

        // 清空关键字标签
        _this.dynamicTags = [];
      },


      // 提交
      onSubmit() {

        if (_this.dynamicTags.length > 6) {

          this.$message.error('关键字不能超过6条');
          return;

        }

        // 将关键字标签转换为JSON格式
        _this.submit_data.key_synchronization = JSON.stringify(_this.dynamicTags);

        console.log(_this.submit_data);

        _this.$post(
            "/help/editHelpSubmit",
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {

            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();
            this.$message.success(res.msg);


          }).catch(res => {

          })
      },

    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .verify_remarks {
    font-size: 14px;
    color: #606266;
  }

  .quill-editor {
    width: 80%;
  }

  .el-tag+.el-tag {
    margin-left: 10px;
  }

  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>